// Phone number input validation regex - allows digits, spaces, parentheses, and hyphens
export const PHONE_NUMBER_REGEX = /[\d\s\(\)\-]/;
